import ListedSuccess from "@/assetsV3/marketplace/ListedSuccess";

export const ListSuccessStep = () => {

  return (
    <div className="flex gap-[11px] w-full h-full justify-center items-center flex-col p-6">
      <ListedSuccess />
      <span className="text-[21px] font-bold font-inter text-outext-main">
        Chip Listed
      </span>
      <span className="text-base text-center font-normal font-inter text-outext-sub">
        You can find your listing under your “My Listings” in marketplace.
      </span>
    </div>
  );
};
